<div class="footer d-flex justify-content-end">
    <div
        class="d-flex justify-content-end btn group p-1"
        (mouseover)="onMouseOver()">
        <div class="btn-group">
            <div *ngIf="showSecondaryButton">
                <button
                    type="button"
                    (click)="onCancel()"
                    class="btn btn-danger text-light mx-1">
                    Cancelar
                </button>
            </div>
            <div>
                <button
                    type="submit"
                    class="btn btn-primary mx-1"
                    (click)="onSubmit()">
                    {{ customSubmitLabel }}
                </button>
            </div>
        </div>
    </div>
</div>
